module.exports = __webpack_public_path__ + "static/media/fetal-pillow@2x.94ea4582.png";